export const COMPANY_WAS_REMOVED_FROM_FAVORITES = 'was removed from Favorites'
export const COMPANY_WAS_ADDED_TO_FAVORITES = 'was added to Favorites'

export const getCompanyRemoveModalMessage = (companyName?: string) =>
  `Are you sure that you want to remove ${
    companyName || 'this company'
  } from favorites?`

export const getCompanyRemoveModalTitle = (companyName?: string) =>
  `Remove ${companyName || 'this company'} from favorites?`
